import type { CartAddressData } from '../../../types';

/** Returns whether the missing-address hint should be shown after billing validation fails. */
export function shouldShowMissingBillingAddressError(
  billingMatchesShipping: boolean,
  billingAddress: CartAddressData | undefined,
  billingFieldErrorCount: number
): boolean {
  // Only show the missing-address hint after the billing form has produced validation errors.
  return !billingMatchesShipping && !billingAddress && billingFieldErrorCount > 0;
}
